module.exports = __webpack_public_path__ + "res/img_back_rtl.f642b625f1e6a24ce59786d940ebc22b.png";